// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/shared/colors.css\"","ot_primary":"#3395FF","ot_white":"#fff","ot_gray":"#888","tabContainer":"tabs__tabContainer___1b1oi","tab":"tabs__tab___Kyctu","selectedTab":"tabs__selectedTab___3LBAv tabs__tab___Kyctu"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/lib/buttons/tabs.css
// module id = 1132
// module chunks = 0